import { Group, Text } from "@mantine/core"

import {
  textColorCssVariable,
  textFontSizeCSSVariable,
  textFontWeightCSSVariable,
} from "@tfg/types/schemas/communication-studio/cssVariables"

import { IconLogo } from "../../../icons/logos/IconLogo"
import { useGetTranslationsContext } from "../context/translationsContext/useGetTranslationsContext"
import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

type Props = {
  customStyles?: {
    [key: string]: string
  }
}

export const AGECDataPending = ({ customStyles }: Props) => {
  const { t } = useGetTranslationsContext()
  return (
    <Group justify="center" align="center" wrap="nowrap">
      <IconLogo height={14} />
      <Text
        className={customStyles?.dataPending}
        c={DesignStudioParametersToolkit.getCssVariableLiteralName(
          textColorCssVariable
        )}
        fw={DesignStudioParametersToolkit.getCssVariableLiteralName(
          textFontWeightCSSVariable
        )}
        fz={DesignStudioParametersToolkit.getCssVariableLiteralName(
          textFontSizeCSSVariable
        )}
      >
        {t("loading.dataPending")}
      </Text>
    </Group>
  )
}
